// Open/Close Filter 
jQuery(document).ready(function ($) {
    $('.filter-button').on('click', function() {
        $(this).children().last().slideToggle();
        $(this).toggleClass('active');
    });
});

// Filter for press release categories
jQuery(document).ready(function ($){
    $(".press-cat").each(function () {
        $(this).on("click", function () {
          $('.press-cat').removeClass('active');
          $(this).addClass('active');
          $('.single-puff').removeClass('active');
          $('.single-puff[data-id*=' + $(this).attr('data-id') + ']').addClass('active');
          if ($(this).data('id') == 'all-items') {
            $('.single-puff').addClass('active');
          }
        });
    });
});